import React from "react";
import PropTypes from "prop-types";
import { XIcon } from "./Icons.js";
import { Button } from "../ui/Button";

export const Drawer = ({ isOpen, onClose, title, children, size }) => {
  if (!isOpen) return null;

  let sizeClass = "";
  if (size === "wide") {
    sizeClass = "drawer-wide";
  } else if (size === "medium") {
    sizeClass = "drawer-medium";
  }

  return (
    <div className="drawer-overlay-container">
      <button
        type="button"
        className="drawer-overlay"
        onClick={onClose}
        aria-label="Close modal"
      ></button>
      <dialog
        open
        className={`drawer-content ${sizeClass}`.trim()}
        aria-modal="true"
        aria-labelledby="drawer-title"
      >
        <div className="drawer-header">
          <h3 id="drawer-title" className="drawer-title">
            {title}
          </h3>
          <Button
            type="button"
            onClick={onClose}
            className="drawer-close-btn"
            aria-label="Close drawer"
          >
            <XIcon size="sm" />
          </Button>
        </div>
        <div
          className="drawer-body"
          style={{ flex: 1, overflowY: "auto", padding: "0.25rem 0 1rem 0" }}
        >
          {children}
        </div>
      </dialog>
    </div>
  );
};

Drawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(["small", "medium", "wide"]),
};
